import { combineReducers } from '@reduxjs/toolkit';
import createUserReducer from './create-user';
import createUserRoleReducer from './create-user-role';
import deleteUserReducer from './delete-user';
import getOperatorReducer from './get-operator';
import getOrganizationAdminReducer from './get-organization-admin';
import getUserListReducer from './get-user-list';
import getUserRoleListReducer from './get-user-role-list';
import updateMyProfileReducer from './update-my-profile';
import updateUserReducer from './update-user';
import updateUserRoleReducer from './update-user-role';
import upsertOperatorReducer from './upsert-operator';
import upsertOrganizationAdminReducer from './upsert-organization-admin';

const userReducer = combineReducers({
  createUser: createUserReducer,
  createUserRole: createUserRoleReducer,
  deleteUser: deleteUserReducer,
  getOperator: getOperatorReducer,
  getOrganizationAdmin: getOrganizationAdminReducer,
  getUserList: getUserListReducer,
  getUserRoleList: getUserRoleListReducer,
  updateMyProfile: updateMyProfileReducer,
  updateUser: updateUserReducer,
  updateUserRole: updateUserRoleReducer,
  upsertOperator: upsertOperatorReducer,
  upsertOrganizationAdmin: upsertOrganizationAdminReducer
});

export default userReducer;